var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 24C37 38.0938 24 44 24 44C24 44 11 39.375 11 24C11 8.625 24 4 24 4C24 4 37 9.90625 37 24Z",
    stroke: "#333",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 36L29 31",
    stroke: "#333",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 29L19 24",
    stroke: "#333",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 23L29 18",
    stroke: "#333",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 44V14",
    stroke: "#333",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.4b4a8499a2e037434a8f013da284affe.svg";
export { ForwardRef as ReactComponent };